// web/src/routes/dashboard/index.jsx
// Renders the correct dashboard based on the user's active role.
// Active role = real role unless the user has "viewed as" something else.
// Permissions are NOT affected by view-as — this is purely a display switch.

import { useAuth } from '../../lib/auth';
import Onboarding from '../onboarding/Onboarding';
import ManagerDashboard from './ManagerDashboard';
import TrainerDashboard from './TrainerDashboard';
import GroomDashboard from './GroomDashboard';
import ClientDashboard from './ClientDashboard';
import ServiceProviderDashboard from './ServiceProviderDashboard';

export default function DashboardIndex() {
  const { user, barns, activeRole, loading } = useAuth();

  if (loading) {
    return <div className="p-6 text-ink-400">Loading…</div>;
  }
  if (!user) {
    return <div className="p-6 text-ink-400">Not signed in.</div>;
  }
  if (!activeRole) {
    // Brand-new account with no barn yet → first-run onboarding.
    if (!barns || barns.length === 0) {
      return <Onboarding />;
    }
    // Has memberships but no active barn on the session (e.g. just logged in).
    return (
      <div className="p-6 max-w-md mx-auto mt-12">
        <div className="card p-6 text-center">
          <h2 className="font-semibold mb-2">No barn selected</h2>
          <p className="text-sm text-ink-500">
            Pick a barn from the menu to continue.
          </p>
        </div>
      </div>
    );
  }

  const role = activeRole;

  switch (role) {
    case 'owner':
    case 'manager':
      return <ManagerDashboard />;
    case 'trainer':
      return <TrainerDashboard />;
    case 'groom':
      return <GroomDashboard />;
    // Riders share the client dashboard. It's the right shape — "how are my
    // horses" — and /dashboard/client scopes per-user via lib/access, so a
    // rider gets the horses they're scheduled on without a separate screen.
    case 'client':
    case 'rider':
      return <ClientDashboard />;
    case 'service_provider':
      return <ServiceProviderDashboard />;
    default:
      return (
        <div className="p-6 text-ink-400">
          No dashboard available for role: {role}
        </div>
      );
  }
}
